<template>
<div>
  <v-list>
    <v-list-item
      v-for="item in items"
      :key="item.classId"
      class="pa-2"
    >
      <v-card variant="outlined" link width="100%" @click="clicked(item.classId)">
        <v-card-text class="black--text">
          <v-row>
            <v-col cols="6">
              {{ item.className }}
            </v-col>
            <v-col cols="3">
              {{ `${item.childrenAge}歳` }}
            </v-col>
            <v-col cols="3">
              {{ `${item.year}年度` }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-list-item>
  </v-list>
</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'ClassList',

  props: {
    items: {
      default: [],
    }
  },

  methods: {
    clicked(classId: string) {
      this.$emit('click', classId);
    },
  },
})
</script>